import { answerOf, dayLabel, onDay, timeLabel, today as todayDay } from '../../lib/calendar.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-agenda ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    days: Array,
    items: Array,
    countdowns: { type: Object, default: null },
    on_open: { type: Function, state: true, default: () => {} },
  }

  open(key) {
    this.state.on_open(key)
  }

  beforeRender() {
    const items = this.props.items || []
    const today = todayDay()
    this.state.groups = this.props.days
      .map((day) => {
        const here = onDay(items, day).sort((a, b) => Number(b.all_day) - Number(a.all_day) || a.startAt - b.startAt)
        return {
          day,
          today: day === today,
          label: dayLabel(day, { weekday: 'long', month: 'long', day: 'numeric' }),
          rows: here.map((item) => ({
            ...item,
            time: item.all_day ? 'All day' : item.firstDay === day ? `${timeLabel(item.startAt)} - ${timeLabel(item.endAt)}` : `until ${timeLabel(item.endAt)}`,
            answer: item.cancelled ? { label: 'Cancelled', tone: 'danger' } : item.waiting ? { label: 'Update waiting', tone: 'warning' } : answerOf(item.my_partstat),
          })),
          counts: this.props.countdowns?.[day] || [],
        }
      })
      .filter((group) => group.rows.length || (group.today && group.counts.length))
  }

  CSS = `:fez {
display:block;height:100%;overflow-y:auto;.ag{max-width:var(--content-width);margin:0 auto;padding:var(--space-4) var(--space-4) var(--space-10)}.ag-day + .ag-day{margin-top:var(--space-5)}.ag-label{margin-bottom:var(--space-2);color:var(--color-text-muted);font-size:var(--text-sm);font-weight:var(--weight-semibold);&.today{color:var(--color-accent)}}.ag-counts{display:flex;flex-wrap:wrap;gap:var(--space-1) var(--space-3);margin:calc(-1 * var(--space-1)) 0 var(--space-2)}.ag-count{display:inline-flex;align-items:center;gap:var(--space-1);padding:0;border:0;background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);cursor:pointer;&:hover{color:var(--color-text)}}.ag-row{display:flex;align-items:baseline;gap:var(--space-3);width:100%;padding:var(--space-3);border:0;border-left:3px solid var(--tag);border-radius:var(--radius-md);background:var(--color-bg-subtle);color:var(--color-text);font:inherit;text-align:left;cursor:pointer;& + .ag-row{margin-top:var(--space-2)}&:hover{background:var(--color-bg-hover)}&.cancelled .ag-title{text-decoration:line-through;opacity:0.7}}.ag-time{flex:none;width:128px;color:var(--color-text-muted);font-size:var(--text-sm)}.ag-text{display:grid;flex:1;gap:2px;min-width:0}.ag-title{font-weight:var(--weight-semibold)}.ag-where{overflow:hidden;color:var(--color-text-muted);font-size:var(--text-sm);text-overflow:ellipsis;white-space:nowrap}.ag-side{display:flex;flex:none;align-self:center;align-items:center;gap:var(--space-2)}.ag-dots{display:inline-flex;gap:3px}.ag-dot{width:8px;height:8px;border-radius:var(--radius-full);background:var(--tag)}.ag-empty{display:grid;place-items:center;height:100%} :mobile {.ag{padding:var(--space-3) var(--space-3) var(--space-8)}.ag-row{flex-wrap:wrap}.ag-time{width:auto;flex-basis:100%}}
}`

  HTML = `{#if state.groups.length}
<div class="ag">
{#each state.groups as group}
<section class="ag-day" key={group.day}>
<h2 class="ag-label" class:today={group.today}>{group.label}</h2>
{#if group.counts.length}
<div class="ag-counts">
{#each group.counts as count}
<button type="button" class="ag-count" key={count.key} onclick="fez.open('{count.key}')"><ui-icon name="hourglass-simple" size="12"></ui-icon>{count.text}</button>
{/each}
</div>
{/if}
{#each group.rows as row}
<button type="button" class="ag-row" class:cancelled={row.cancelled} style="--tag: var(--color-avatar-{row.color})" onclick="fez.open('{row.key}')">
<span class="ag-time">{row.time}</span>
<span class="ag-text">
<span class="ag-title">{row.title}</span>
{#if row.location}<span class="ag-where">{row.location}</span>{/if}
</span>
<span class="ag-side">
{#if row.answer}<ui-badge tone={row.answer.tone} label={row.answer.label}></ui-badge>{/if}
<span class="ag-dots">{#each row.colors as color}<span class="ag-dot" style="--tag: var(--color-avatar-{color})"></span>{/each}</span>
</span>
</button>
{/each}
</section>
{/each}
</div>
{:else}
<div class="ag-empty"><ui-empty icon="calendar-blank" title="Nothing coming up" text="No events in the next 30 days."></ui-empty></div>
{/if}`
};
}

Fez('calendar-agenda', __fez_component_0);

export default __fez_component_0;
